import { render, staticRenderFns } from "./FormTableMpsTextarea.vue?vue&type=template&id=f0e2484c&scoped=true"
import script from "./FormTableMpsTextarea.vue?vue&type=script&lang=js"
export * from "./FormTableMpsTextarea.vue?vue&type=script&lang=js"
import style0 from "./FormTableMpsTextarea.vue?vue&type=style&index=0&id=f0e2484c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e2484c",
  null
  
)

export default component.exports